import { FC } from "react";
import { Typography } from "@mui/material";
import __ from "src/utils/Translations";
import Avatar from "src/Components/Avatar";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

interface IEmployeesAutocompleteAdornmentProps {
  data?: IEmployeeDetails | null;
}

const EmployeesAutocompleteAdornment: FC<
  IEmployeesAutocompleteAdornmentProps
> = ({ data }) => (
  <>
    <Avatar
      src={data?.avatarUrl}
      initials={data?.initials ?? ""}
      size="24px"
      fontSize="12px"
      employeePresence={data?.presenceStatus}
    />
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        fontSize: "12px",
        lineHeight: "1",
        position: "absolute",
        left: "46px",
        top: "31px",
      }}
    >
      {data?.position || __("Brak stanowiska")}
    </Typography>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        fontSize: "12px",
        lineHeight: "1",
        position: "absolute",
        left: "46px",
        top: "46px",
      }}
    >
      {__("Numer kadrowy")}: {data?.fkNumber}
    </Typography>
  </>
);

export default EmployeesAutocompleteAdornment;
